import { createSelector } from 'reselect'

import { selectStrategicInitiativesState } from './selectStrategicInitiativesState'

export const selectStrategicInitiativesOfferingsList = createSelector(
  [selectStrategicInitiativesState],
  (state) => state.offeringsList
)
